import { AfterViewChecked, Component, EventEmitter, Input, Output, computed, input, inject } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TypeaheadSearchComponent } from '@r1-compass-library/components';
import { ComparatorMetadata } from '@r1-compass-library/models/content-library/content-library.model';
import { WebActivitySelectionCriterionDataForm } from '@r1-compass-library/models/criteria/selection-criteria-form.model';
import { faGlobe, faTrash } from '@fortawesome/pro-solid-svg-icons';
import { DataMartCmt, DataMartField, DataMartPicklistValue } from '@r1-compass-library/models';
import { DataMartService } from '@r1-compass-library/services';

@Component({
    selector: 'r1-compass-app-web-activity-criterion',
    imports: [
        TypeaheadSearchComponent,
        FontAwesomeModule,
        FormsModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        ReactiveFormsModule,
    ],
    templateUrl: './web-activity-criterion.component.html',
    styleUrl: './web-activity-criterion.component.scss',
})
export class WebActivityCriterionComponent implements AfterViewChecked {
    readonly #dataMartService = inject(DataMartService);

    @Input()
    criterionForm: FormGroup<WebActivitySelectionCriterionDataForm> = new FormGroup(
        new WebActivitySelectionCriterionDataForm()
    );

    readonly deletable = input<boolean>(true);

    readonly displayOnly = input<boolean>(false);

    readonly displayIndex = input<boolean>(true);

    required = input.required<boolean>();

    index = input.required<number>();

    cmtLevels = input.required<DataMartPicklistValue[]>();

    webActivityPeriodFields = input.required<DataMartField[]>();

    @Output()
    deleteCriterion: EventEmitter<number> = new EventEmitter<number>();

    tabClass = computed(() => (this.required() ? 'criterion-index-tab required-row-tab' : 'criterion-index-tab'));

    comparators: ComparatorMetadata[] = [
        { label: '=', value: 'equals', valueType: 'text' },
        { label: '>', value: 'greaterThan', valueType: 'text' },
        { label: '<', value: 'lessThan', valueType: 'text' },
        { label: '<=', value: 'lessThanOrEqualTo', valueType: 'text' },
        { label: '>=', value: 'greaterThanOrEqualTo', valueType: 'text' },
    ];

    categoryTypeaheadResults: DataMartCmt[] = [];

    faTrash = faTrash;
    faGlobe = faGlobe;

    type = 'Web Activity';

    constructor() {
        const library = inject(FaIconLibrary);

        library.addIcons(faTrash);
    }

    ngAfterViewChecked() {
        if (this.displayOnly()) {
            this.criterionForm.disable();
        }
    }

    onLevelSelect() {
        this.criterionForm.controls.cmtCategory.reset();
        this.categoryTypeaheadResults = [];
    }

    onDelete() {
        this.deleteCriterion.emit(this.index());
    }

    onTypeaheadSearch(search: string) {
        const cmtLevel = Number(this.criterionForm.controls.cmtLevel.value);
        if (cmtLevel) {
            this.#dataMartService.cmtSearch(cmtLevel, search).subscribe(cmtResponse => {
                this.categoryTypeaheadResults = cmtResponse.entries;
            });
        }
    }
}
